module.exports = __webpack_public_path__ + "img/40_69_000_810.8f6479e7.jpg";